import './assets/slick.1.9.0.min.js';

//import slickCss from 'slick-carousel/slick/slick.css';

class TravelsTeaser {
  constructor($main) {
    if (!this.initDomElements($main)) return false;
    this.initSlider();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.inside = this.domElements.main.find(
        '.travels-teaser__inside');
    this.domElements.items = this.domElements.main.find(
        '.travels-teaser__items');
    this.domElements.navigation = this.domElements.main.find(
        '.travels-teaser__controls');
    return true;
  }

  initSlider() {
    if (this.domElements.items.find('>*').length < 2) {
      return;
    }

    const options = {
      dots: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 400,
      fade: false,
      autoplay: false,
      adaptiveHeight: true,
      appendArrows: this.domElements.navigation,
      nextArrow: '<button class="slick-next slick-arrow" aria-label="weiter" type="button" style=""></button>',
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="zurück" type="button" style=""></button>',

      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3
          }
        },

        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    const slider = this.domElements.items.slick(options);
  }
}

export default TravelsTeaser;
